var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-gray-100 bg-gray-800 min-h-screen flex flex-col",attrs:{"id":"app"}},[_c('TheHeader',{staticClass:"z-50"}),_c('TheDrawerMenu',{staticClass:"z-40"}),_c('LDefault',[_c('router-view')],1),_c('CookiesModal',{staticClass:"z-30"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }